import React from 'react'
import { useParams } from 'react-router-dom'
import { ChangePassword as ChangePasswordCore } from '@ztechapps/webui.auth'
import { Card } from 'react-bootstrap'
import { routesDef } from '../../../config/routes'
import { appSettings } from '../../../config/app-settings'
import { LoginOverview } from '../../../components/login-overview'

export const ChangePassword = () => {
  const { username: resetUsername, code: resetCode } = useParams()
  const recaptchaSiteKey = appSettings?.Google?.recaptchaSiteKey

  const content = (
    <ChangePasswordCore
      url={`/api/auth/basic/change-password`}
      resetUsername={resetUsername}
      resetCode={resetCode}
      navigateTo={routesDef.LoginPage.altPath}
      recaptchaSiteKey={recaptchaSiteKey}
    />
  )

  return (
    <LoginOverview>
      <Card>
        <Card.Body>{content}</Card.Body>
      </Card>
    </LoginOverview>
  )
}
